import { useParams } from 'react-router-dom';

import { useShippingAndBillingDetails } from '@/components/modules/ShippingAndBilling/_shared/hooks/useShippingAndBillingDetails';
import { ShippingAndBilling } from '@/components/modules/ShippingAndBilling/_shared/ShippingAndBilling';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const OrderShippingAndBilling = () => {
  const { loanId } = useParams();

  if (!loanId) return null;

  const { shipping, billing } = useShippingAndBillingDetails({ loanId });

  return <ShippingAndBilling shipping={shipping} billing={billing} />;
};

export const OrderShippingAndBillingModule = withPermissionsModule(OrderShippingAndBilling);
